import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-isolation-list',
  templateUrl: './isolation-list.component.html',
  styleUrls: ['./isolation-list.component.css']
})
export class IsolationListComponent {
  @ViewChild('dt') dt: Table | undefined;

  isolationlist: any[] = [];
  loading: boolean = true;
  selectedSample: any;
  cols: any[] = [];

  constructor(private dataService: DataService,
    private router: Router) { }

  ngOnInit() {
    const filters = localStorage.getItem("filters");

    this.dataService.getIsolationList().then(data => {
      this.isolationlist = data;
      this.loading = false;
    });

    this.cols = [
      { field: 'instrument', header: 'Instrument' },
      { field: 'startDate', header: 'Start Date' },
      { field: 'endDate', header: 'End Date' },
      { field: 'isoIncident', header: 'Incident' },
      { field: 'isoIncidentDate', header: 'Incident Date' },
      { field: 'isoService', header: 'Service' },
      { field: 'isoServiceDate', header: 'Service Date' }
    ]
  }

  clear(table: Table) {
      table.clear();
  }

  applyFilterGlobal($event:any, stringVal:any) {
    this.dt?.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  rowClick(record: any){
    //this.router.navigate(['detail',record.sampleId]);
  }
}
